import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Dynamic extends ModelPrototype {
  public async get(): Promise<any> {
    try {
      return this.withUrl(`main/dynamic_block`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
